/* unplugin-vue-components disabled */import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "editor-drawer__text flex flex-col gap-4"
};
const _hoisted_2 = ["onClick"];
import { useConfiguratorStore } from "@/stores/configurator";
import { useCreateEditorText } from '@/composables/2dEditor/useCreateEditorText';
export default {
  __name: 'EditorDrawerText',
  setup(__props) {
    const $eventBus = inject('bus');
    const configuratorStore = useConfiguratorStore();
    const {
      closeDrawer
    } = configuratorStore;

    // @TODO: Put label in translation
    const textSizes = computed(() => {
      return [{
        slug: 'small',
        label: 'Small text',
        fontSize: '16px'
      }, {
        slug: 'medium',
        label: 'Medium text',
        fontSize: '24px'
      }, {
        slug: 'large',
        label: 'Large text',
        fontSize: '32px'
      }];
    });
    function onClickHandleText(size) {
      const params = {
        isNew: true,
        size
      };
      const obj = useCreateEditorText(params);
      $eventBus.$emit("object-added-new", obj);
      closeDrawer();
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(textSizes), (size, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: `text-size-${size.slug}-${index}`,
          class: "flex-1 bg-slate-800 text-white p-4 rounded-lg hover:opacity-80",
          onClick: $event => onClickHandleText(size.slug)
        }, [_createElementVNode("p", {
          style: _normalizeStyle({
            fontSize: size.fontSize
          })
        }, _toDisplayString(size.label), 5)], 8, _hoisted_2);
      }), 128))]);
    };
  }
};